module.exports = __webpack_public_path__ + "img/bad.42659dfd.svg";